import { render, staticRenderFns } from "./CompanyActivities.vue?vue&type=template&id=151d3ab0&"
import script from "./CompanyActivities.vue?vue&type=script&lang=js&"
export * from "./CompanyActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports